export default {
  'TopNavMenu.Home':'首页',
  'TopNavMenu.Author':'作者专区',
  'Action.Logout':'退出登录',
  'NavTwo.SiderMenu.TeacherList':'老师列表',
  'NavTwo.SiderMenu.FilmList':'影片列表',
  'NavTwo.SiderMenu.Menu':'菜单',
  'NavTwo.SiderMenu.Menu.One':'菜单一',
  'NavTwo.SiderMenu.Menu.Two':'菜单二'
}